<template>
  <div class="header custom-background-blue d-flex justify-content-center align-items-center">
    <div class="w-80 d-flex justify-content-between align-items-center">
      <div class="d-flex justify-content-center align-items-center">
        <h4 @click="navigateTo('LabHub')" class="text-light m-0 link-list-exercise">Laboratório Digital</h4>
        <div class="responsive text-divider bg-light mx-5"></div>
        <p class="responsive text-light m-0">Plataforma de Treinamento Industrial</p>
      </div>

      <div class="d-flex flex-sm-row flex-column justify-content-center align-items-center">
        <button
            v-if="hasTour"
            @click="restartTour"
            class="btn-restart-tour me-3"
            title="Reiniciar tour da página"
            aria-label="Reiniciar tour guiado"
        >
          <i class="bi bi-question-circle"></i>
        </button>

        <dropdown-menu mode="hover" :overlay="false">
          <template #trigger>
            <div class="dropdown-trigger-user">
              <div class="w-100 d-grid text-center">
                <span>{{ userName }}</span>
                <span class="profile-type">{{ profileType }}</span>
              </div>

              <img :src="UserAvatarIcon"
                   class="ms-2 avatar"
                   alt="Ícone de um perfil de usuário"
              >
            </div>
          </template>

          <template #header>
            <div class="flex justify-self-center m-2">
              {{ userUsername }}
            </div>
          </template>

          <template #body>
            <div class="w-100">
              <div class="w-100 divider"></div>

              <div class="w-100" v-for="item in menu" :key="item.name">
                <button @click="navigateTo(item.name)"
                        class="custom-button-feedback custom-color-blue">
                  <i :class="item.icon"></i> {{ item.label }}
                </button>
              </div>

              <div class="w-100">
                <button @click="openModalFeedback"
                        class="custom-button-feedback custom-color-blue">
                  <i class="bi bi-chat-right-text-fill"></i> Dar Feedback
                </button>
              </div>

              <div class="w-100 divider"></div>
            </div>
          </template>

          <template #footer>
            <div class="w-100">
              <button @click="logoutUser"
                      class="custom-button-logout d-flex justify-content-center align-items-center">Sair
                <img :src="ImageLogoutButton"
                     class="ms-2 text-black"
                     alt="Ícone de porta com uma flecha no meio que aponta para a direita">
              </button>
            </div>
          </template>
        </dropdown-menu>

        <ModalFeedback ref="modalFeedbackRef"/>
      </div>
    </div>
  </div>
</template>

<script setup>
import ModalFeedback from '@/components/Modals/ModalFeedback.vue';
import ImageLogoutButton from "@/assets/images/logoutButton.svg";
import UserAvatarIcon from "@/assets/images/avatarIcon.png";
import {useRouter, useRoute} from 'vue-router';
import {onMounted, ref, computed} from 'vue';
import {useAuthStore} from '@/stores/auth';
import {useLogsStore} from "@/stores/logs";
import { useLaboratoryStore } from '@/stores/laboratoryStore';

const TOUR_PAGES = ['LabHub', 'ListExercises', 'Exercise', 'StudentPanel'];

const router = useRouter();
const route = useRoute();
const modalFeedbackRef = ref(null);
const menu = ref([]);
const authStore = useAuthStore();
const logsStore = useLogsStore();
const labStore = useLaboratoryStore();

const hasTour = computed(() => TOUR_PAGES.includes(route.name));

function restartTour() {
    window.dispatchEvent(new CustomEvent('restart-tour'));
}

const userName = ref(authStore.getLoggedInUsernameAndName()?.name);
const userUsername = ref(authStore.getLoggedInUsernameAndName()?.username);
const profileType = ref(authStore.getLoggedInUsernameAndName()?.profile);

async function logoutUser() {
  const responseLogout = await authStore.logout();

  if (responseLogout.success) {
    router.push({name: 'Login'});
  }
}

function openModalFeedback() {
  modalFeedbackRef.value.openModal();
}

function navigateTo(page) {
  if (page === 'ListExercises') {
    if (labStore.currentLab && labStore.currentLab.slug) {
      router.push({
        name: 'ListExercises',
        params: { lab_slug: labStore.currentLab.slug }
      });
    } else {
      router.push({ name: 'LabHub' });
    }
  }
  else {
    router.push({ name: page });
  }
}

onMounted(() => {
  logsStore.init();
  authStore.getMenu()
      .then(menuData => menu.value = menuData);
});
</script>

<style scoped>
.header {
  min-height: 6.5%;
  max-height: 6.5%;
}

@media only screen and (max-width: 575px) {
  .header {
    max-height: 12% !important;
    min-height: 12% !important;
  }

  .custom-button-feedback {
    margin-bottom: 0.5rem;
  }
}

@media only screen and (max-width: 1000px) {
  .responsive {
    display: none;
  }
}

@media only screen and (max-height: 750px) {
  .header {
    max-height: 12% !important;
    min-height: 12% !important;
  }
}

.text-divider {
  width: 2px;
  height: 42px;
}

.divider {
  border-bottom: #E8EFFB 1px solid;
}

.custom-button-feedback {
  text-align: left;
  margin-left: 1rem;
  background-color: unset;
  width: 100%;
  height: 35px;
  border: 1px;
  transition: 0.2s linear;
}

.custom-button-feedback:hover, .custom-button-logout:hover {
  background-color: #d1ddf3;
}

.custom-button-logout {
  background: transparent;
  width: 100%;
  height: 35px;
  color: #1A5FD5;
  outline: none;
  border: none;
}

.link-list-exercise {
  cursor: pointer;
  transition: linear .2s;
}

.link-list-exercise:hover {
  color: #d1ddf3 !important;
}

.dropdown-trigger-user {
  display: flex;
  align-items: center;
  color: white;
}

.avatar {
  width: 32px;
  height: 32px;
}

.profile-type {
  font-size: 15px;
  margin-top: -2px;
}

.btn-restart-tour {
  background: transparent;
  border: 1.5px solid rgba(255, 255, 255, 0.6);
  color: white;
  border-radius: 50%;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: 0.2s;
  font-size: 1rem;
}

.btn-restart-tour:hover {
  background: rgba(255, 255, 255, 0.15);
  border-color: white;
}
</style>